import { render, staticRenderFns } from "./terminos-condiciones.vue?vue&type=template&id=149b37cb&scoped=true"
import script from "./terminos-condiciones.vue?vue&type=script&lang=js"
export * from "./terminos-condiciones.vue?vue&type=script&lang=js"
import style0 from "./terminos-condiciones.vue?vue&type=style&index=0&id=149b37cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149b37cb",
  null
  
)

export default component.exports